export const trilingualModel = {
  title: "Modèle Trilingue Progressif",
  subtitle: "Immersion en anglais qui grandit à chaque étape",
  stages: {
    infantil: {
      title: "Maternelle (3-6 ans)",
      percentage: "40%",
      description: "Introduction naturelle à l'anglais dans les routines, jeux et activités quotidiennes"
    },
    cycle1: {
      title: "Primaire Cycle 1 (6-9 ans)",
      percentage: "45%",
      description: "Zones non linguistiques comme Science et Arts en anglais, consolidant la base communicative"
    },
    cycle2: {
      title: "Primaire Cycle 2 (9-12 ans)",
      percentage: "50%",
      description: "Moitié du programme en anglais, avec fluidité complète dans les contextes académiques et sociaux"
    }
  },
  footer: "L'espagnol et le galicien sont présents à toutes les étapes, garantissant la maîtrise des trois langues"
};
